'use client';

import dynamic from 'next/dynamic';

export const DynamicInspiringSearchOnboardingModal = dynamic(
  () => import('./InspiringSearchOnboardingModal'),
  {
    ssr: false,
  },
);
